import { formatCurrency } from '../../utils/formatters';

function ProfitLossStatement({ data }) {
  const renderSection = (items) => (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.label} className="flex justify-between items-center">
          <span className={`text-sm ${item.isTotal ? 'font-semibold' : ''}`}>
            {item.label}
          </span>
          <span className={`text-sm ${item.isTotal ? 'font-semibold' : ''} ${item.value < 0 ? 'text-red-600' : ''}`}>
            {formatCurrency(item.value)}
          </span>
        </div>
      ))}
    </div>
  );

  return (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <h2 className="text-xl font-semibold mb-6">Profit & Loss Statement</h2>

      {/* Revenue Section */}
      <div className="mb-8">
        <h3 className="text-sm font-medium text-gray-500 mb-4">Revenue</h3>
        {renderSection(data.revenue)}
      </div>

      {/* Cost of Goods Section */}
      <div className="mb-8">
        <h3 className="text-sm font-medium text-gray-500 mb-4">Cost of Goods</h3>
        {renderSection(data.costOfGoods)}
      </div>

      {/* Operating Expenses Section */}
      <div className="mb-8">
        <h3 className="text-sm font-medium text-gray-500 mb-4">Operating Expenses</h3>
        {renderSection(data.operatingExpenses)}
      </div>

      {/* Net Profit Section */}
      <div className="pt-4 border-t border-gray-200">
        <div className="flex justify-between items-center">
          <span className="text-lg font-bold">Net Profit</span>
          <span className={`text-lg font-bold ${data.netProfit < 0 ? 'text-red-600' : 'text-green-600'}`}>
            {formatCurrency(data.netProfit)}
          </span>
        </div>
      </div>
    </div>
  );
}

export default ProfitLossStatement;